export default function getInitials(name) {
  if (!name) return null;
  let parts = name.split(" ");
  let initials = name[0];
  if (parts.length > 1) {
    initials += parts[1][0];
  }
  return initials;
}
